module.exports = __webpack_public_path__ + "img/ARDR-alt.d4f30e92.svg";